import React from 'react';
import { motion } from 'framer-motion';
import { Gift, FileText, CreditCard, CheckCircle } from 'lucide-react';
export function BonusesSection() {
  return <section className="py-24 bg-brand-dark text-white relative overflow-hidden" data-id="element-26">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#D4A843_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-27"></div>

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-28">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-gold/20 mb-6" data-id="element-30">
            <Gift className="w-8 h-8 text-brand-gold" data-id="element-31" />
          </div>
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6" data-id="element-32">
            Además, recibes estos{' '}
            <span className="text-brand-gold" data-id="element-33">BONOS PREMIUM</span>
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-34">
            Herramientas exclusivas diseñadas para acelerar tus resultados y
            ahorrarte horas de investigación.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-35">
          {/* Bonus 1 */}
          <motion.div className="bg-brand-green/20 border border-brand-gold/30 rounded-2xl p-8 backdrop-blur-sm" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-36">
            <div className="flex justify-center mb-6" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/nuVUfARUKGq3eMFr4UiEUk/ChatGPT_Image_24_abr_2026,_19_36_33.png" alt="Kit de Herramientas Crediticias" className="w-80 sm:w-96 h-auto drop-shadow-xl" data-id="element-38" />
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-39">
              <div className="w-14 h-14 bg-brand-gold rounded-xl flex items-center justify-center shrink-0" data-id="element-40">
                <FileText className="w-7 h-7 text-brand-dark" data-id="element-41" />
              </div>
              <div data-id="element-42">
                <div className="text-brand-gold font-bold text-sm tracking-wider uppercase mb-1" data-id="element-43">
                  Bono #1
                </div>
                <h3 className="text-2xl font-bold" data-id="element-44">
                  Kit de Herramientas Crediticias
                </h3>
                <p className="text-white/60 text-sm mt-1" data-id="element-45">
                  Valor real: <span className="line-through" data-id="element-46">$19.99</span> ·{' '}
                  <span className="text-brand-gold font-semibold" data-id="element-47">
                    GRATIS hoy
                  </span>
                </p>
              </div>
            </div>

            <ul className="space-y-4" data-id="element-48">
              {['Cartas de disputa listas para usar', 'Guía paso a paso para enviar disputas', 'Scripts exactos para llamadas al banco', 'Checklist de verificación mensual'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-49">
                  <CheckCircle className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-50" />
                  <span className="text-gray-200" data-id="element-51">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div className="bg-brand-green/20 border border-brand-gold/30 rounded-2xl p-8 backdrop-blur-sm" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-52">
            <div className="flex justify-center mb-6" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/4RceXW5NBDhBwNBpMeeajH/ChatGPT_Image_24_abr_2026,_19_46_34.png" alt="Guía Inteligente para Tarjetas de Crédito en USA" className="w-80 sm:w-96 h-auto drop-shadow-xl" data-id="element-54" />
            </div>
            <div className="flex items-center gap-4 mb-6" data-id="element-55">
              <div className="w-14 h-14 bg-brand-gold rounded-xl flex items-center justify-center shrink-0" data-id="element-56">
                <CreditCard className="w-7 h-7 text-brand-dark" data-id="element-57" />
              </div>
              <div data-id="element-58">
                <div className="text-brand-gold font-bold text-sm tracking-wider uppercase mb-1" data-id="element-59">
                  Bono #2
                </div>
                <h3 className="text-2xl font-bold" data-id="element-60">
                  Guía Inteligente para Tarjetas de Crédito en USA
                </h3>
                <p className="text-white/60 text-sm mt-1" data-id="element-61">
                  Valor real: <span className="line-through" data-id="element-62">$19.99</span> ·{' '}
                  <span className="text-brand-gold font-semibold" data-id="element-63">
                    GRATIS hoy
                  </span>
                </p>
              </div>
            </div>

            <ul className="space-y-4" data-id="element-64">
              {['Tipos de tarjetas explicados al detalle', 'Cuál elegir según tu nivel actual', 'Comparaciones claras y sin jerga', 'Estrategia para evitar intereses y errores'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-65">
                  <CheckCircle className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-66" />
                  <span className="text-gray-200" data-id="element-67">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}